export default function localeUrl(path = ''): string {

    return `${window.location.protocol}//${window.location.host}${path}`
}